"use strict";

Shopify.theme.jsProduct = {
  init: function init($section, handle = "") {
    // Add settings from schema to current object
    Shopify.theme.jsProduct = $.extend(this, Shopify.theme.getSectionData($section)); //Ensure product media libraries are present

    window.Shopify.loadFeatures([{
      name: 'model-viewer_old',
      version: '0.8'
    }, {
      name: 'shopify-xr_old',
      version: '1.0'
    }, {
      name: 'model-viewer-ui_old',
      version: '1.0'
    }], Shopify.theme.productMedia.setupMedia);
    this.$section = $section;
    this.handle = handle || (window.location.pathname.match(/\/products\/([^\/]+)/) && window.location.pathname.match(/\/products\/([^\/]+)/)[1]);
    var $productGallery = $section.find('.product-gallery__main:not(.quick-add-drawer .product-gallery__main)');
    var $stickyElement = $section.find('.sticky-product-scroll');
    var $productPare = $section.find('.mobile-slider__pare');

    if ($productGallery) {
      Shopify.theme.jsProduct.enableSlideshow($productGallery);

      if (Shopify.theme.jsProduct.enable_zoom) {
        document.addEventListener('lazybeforeunveil', Shopify.theme.jsProduct.enableZoom);
      }

      if (Shopify.theme.jsProduct.enable_product_lightbox) {
        Shopify.theme.jsProduct.enableLightbox($productGallery);
      }
    }
    if ( $productPare  && !isScreenSizeLarge()) {
      Shopify.theme.jsProduct.enableMobileSliderPair($productPare);
    }

    if ($stickyElement && isScreenSizeLarge() && Shopify.theme.jsProduct.template == 'image-scroll') {
      Shopify.theme.jsProduct.enableStickyScroll($stickyElement, $productGallery);
    }


    $(".product_form_options", $section).each(function () {
      if ($('.select-container').length) {
        new Shopify.OptionSelectors($(this).data("select-id"), {
          product: $(this).data("product"),
          onVariantSelected: selectCallback,
          enableHistoryState: $(this).data("enable-state")
        });
      }
    });

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html(Shopify.translation.notify_form_success);
    }

    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function () {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if ($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function success(data) {
              $nf.fadeOut("slow", function () {
                $nf.prev('.message').html(Shopify.translation.notify_form_success);
              });
            },
            error: function error(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    $('.product__payments-vidget a').on('click', function(e){
      e.preventDefault();
      var content = $(this).siblings('.content-popup').html();
      if ( content.length > 0 ) {
        $.fancybox.open( content );
      } else {
        window.open( $(this).attr('href') );
      }
    });

    $('.product_form--dropdown-advanced .swatch__title').off('click').on('click', function(e){
      if (this.classList.contains('active')) {
        $(this).removeClass('active').siblings('.swatch_options_wrap').slideUp();
      } else {
        $(this).addClass('active').siblings('.swatch_options_wrap').slideDown();
      }
    });
    $(document).mouseup(function (e){ 
      var dropdown = $('.product_form--dropdown-advanced .swatch__title');
      if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) { 
        dropdown.removeClass('active').siblings('.swatch_options_wrap').slideUp(); 
      }
    });

    
    if (Shopify.theme_settings.product_form_style === "swatches" && Shopify.swatches_enable) {
      this.enableProductSwatches();
    } else if (Shopify.theme_settings.product_form_style === "dropdown-advanced") {
      this.enableProductSwatchesAdvanced();
    } else if (Shopify.theme_settings.product_form_style === "dropdown") {
      $('.selector-wrapper select', $section).wrap('<span class="select" data-dropdown-form-style></span>');
      this.findSelectedVariantImage();
    }

    if ($('.masonry--true').length > 0) {
      Shopify.theme.applyMasonry('.thumbnail');
    }
    const afterPayInterval = setInterval(function() {
      if($section.find('square-placement').length) {
        clearInterval(afterPayInterval)
        $section.find('square-placement').addClass('hide')
        setTimeout(function() {          
          const widgetId = $section.find('square-placement').attr('id')
          var style = document.createElement( 'style' )
          style.innerHTML = ' *, span > strong { font-size: 14px; letter-spacing: 0; } .afterpay-logo.black-on-mint .afterpay-logo-badge-background { fill: transparent; } .afterpay-logo-badge-lockup {transform: translate(-13px, 0px) } .afterpay-link {display: none!important;} .afterpay-paragraph { white-space: nowrap; } @media screen and (max-width: 1350px) { span.afterpay-main-text { font-size: 8px; } @media screen and (max-width: 749px) { span.afterpay-main-text { font-size: 12px; } span.afterpay-main-text strong { font-size: 10px !important; } .afterpay-logo.brand-afterpay svg, .afterpay-logo.brand-afterpay {width: 75px !important;} }'
          $section.find('square-placement')[0].shadowRoot.appendChild( style );
          $section.find('square-placement').removeClass('hide')

        }, 5000)
      }
    }, 100)

    this.initStickyQuickBuy();
    this.initProductAccordion();
    this.buildColourOptions();
    this.initInstoreAvailability();
    this.initProductPairItWith();
    this.initProductColourSlider();
    
    window.onorientationchange = function() { 
        var orientation = window.orientation; 
            switch(orientation) { 
                case 0:
                case 90:
                case -90: window.location.reload(); 
                break; } 
    };
  },

  initProductColourSlider() {
    const slider = document.querySelector('.js-product-colors-wrapper');
    let isDown = false;
    let startX;
    let scrollLeft;
    if (slider){
      slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      cancelMomentumTracking();
    });
    
    
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    
    
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
      beginMomentumTracking();
    });
    
    
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      var prevScrollLeft = slider.scrollLeft;
      slider.scrollLeft = scrollLeft - walk;
      velX = slider.scrollLeft - prevScrollLeft;
    });
    
    // Momentum 
    
    var velX = 0;
    var momentumID;
    
    slider.addEventListener('wheel', (e) => {
      cancelMomentumTracking();
    });  
    
    function beginMomentumTracking(){
      cancelMomentumTracking();
      momentumID = requestAnimationFrame(momentumLoop);
    }
    function cancelMomentumTracking(){
      cancelAnimationFrame(momentumID);
    }
    function momentumLoop(){
      slider.scrollLeft += velX;
      velX *= 0.95; 
      if (Math.abs(velX) > 0.5){
        momentumID = requestAnimationFrame(momentumLoop);
      }
    }
    }
  
    
  },

  enableMobileSliderPair: function enableMobileSliderPair($wrapper) {
    $wrapper.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      arrow: false,
      prevNextButtons: false,
      pageDots: false,
    });
  },

  enableStickyScroll: function enableStickyScroll($stickyElement, $productGallery) {
    var announcementHeight = 0;
    var headerHeight = 0;

    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = $('#announcement-bar').outerHeight();
    }

    if (Shopify.theme_settings.header_layout != 'vertical') {
      if (Shopify.theme.jsHeader.enable_sticky) {
        headerHeight = $('#header').outerHeight();
      }
    }

    var productImages = $productGallery.data('media-count'); //enable if more than 1 image is present

    if (productImages > 1) {
      $stickyElement.stick_in_parent({
        offset_top: announcementHeight + headerHeight + 20
      });
    }
  },
  enableLightbox: function enableLightbox($productGallery) {
    $productGallery.find('.product-gallery__link').fancybox({
      beforeClose: function beforeClose(instance, slide) {
        var $instanceGallery = instance.$trigger.first().parents('.product-gallery__main');
        $instanceGallery.hide();
        setTimeout(function () {
          $instanceGallery.fadeIn(100);
        }, 500);
      },
      afterClose: function afterClose() {
        setTimeout(function () {
          $productGallery.find('.is-selected a').focus();
        }, 500);
      }
    });
  },
  enableZoom: function enableZoom() {
    var $image = $(event.target);
    var zoomSrc = $image.data('zoom-src');

    if (zoomSrc) {
      $image.wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
        url: zoomSrc,
        touch: false,
        magnify: 1
      });
    }
  },
  disableSlideshow: function disableSlideshow($section, selector) {
    var $slider;

    if ($section) {
      $slider = $section.find('.flickity-enabled');
    } else {
      $slider = $(selector);
    }

    $slider.flickity('destroy');
  },
  enableSlideshow: function enableSlideshow(selector, settings) {
    // Define variables
    var $productGallery = selector;
    var $thumbnailProductGallery = $productGallery.closest('.product-gallery').find('.product-gallery__thumbnails'); // Adds 'product-gallery__image' class if not present

    $productGallery.find('.gallery-cell:not(.product-gallery__image)').addClass('product-gallery__image'); // Adds 'product-gallery__thumbnail' class if not present

    $thumbnailProductGallery.find('.gallery-cell:not(.product-gallery__thumbnail)').addClass('product-gallery__thumbnail');
    var $slides = $productGallery.find('.product-gallery__image');
    var $thumbnails = $thumbnailProductGallery.find('.product-gallery__thumbnail');
    var thumbnailsEnabled;
    var thumbnailsSliderEnabled;
    var thumbnailsPosition;
    var arrowsEnabled;
    var slideshowSpeed;
    var slideshowTransition;

    if (settings) {
      // If custom settings available, use them otherwise take settings from product templates
      thumbnailsEnabled = settings.thumbnailsEnabled;
      thumbnailsSliderEnabled = settings.thumbnailsSliderEnabled;
      thumbnailsPosition = settings.thumbnailsPosition;
      arrowsEnabled = settings.arrowsEnabled;
      slideshowSpeed = settings.slideshowSpeed;
      slideshowTransition = settings.slideshowTransition;
    } else {
      thumbnailsEnabled = Shopify.theme.jsProduct.thumbnails_enabled;
      thumbnailsSliderEnabled = Shopify.theme.jsProduct.enable_thumbnail_slider;
      thumbnailsPosition = Shopify.theme.jsProduct.thumbnail_position;
      arrowsEnabled = Shopify.theme.jsProduct.thumbnail_arrows;
      slideshowSpeed = Shopify.theme.jsProduct.slideshow_speed;
      slideshowTransition = Shopify.theme.jsProduct.slideshow_transition;
    }

    $productGallery.on('ready.flickity', function () {
      $slides.each(function (index, slide) {
        //Determine media type
        var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
        var videoID;
        var videoLooping = $('[data-video-loop]').data('video-loop');

        switch (mediaType) {
          case 'external_video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (videoPlayers) {
              for (var i = 0; i < videoPlayers.length; i++) {
                if (videoPlayers[i].id == videoID || videoPlayers[i].media.id == videoID) {
                  videoPlayers[i].loop = videoLooping;

                  if (!$(slide).hasClass('is-selected')) {
                    videoPlayers[i].keyboard = {
                      focused: false,
                      global: false
                    };
                  }
                }
              }
            }

            break;

          case 'video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (videoPlayers) {
              for (var _i = 0; _i < videoPlayers.length; _i++) {
                if (videoPlayers[_i].id == videoID || videoPlayers[_i].media.id == videoID) {
                  videoPlayers[_i].loop = videoLooping;

                  if (!$(slide).hasClass('is-selected')) {
                    videoPlayers[_i].keyboard = {
                      focused: true,
                      global: false
                    };
                  }
                }
              }
            }

            break;

          case 'model':
            if ($(slide).hasClass('is-selected')) {
              //When active slide
              if (mediaType == 'model' && isScreenSizeLarge()) {
                $(slide).on('mouseenter', function () {
                  $productGallery.flickity('unbindDrag');
                });
                $(slide).on('mouseleave', function () {
                  $productGallery.flickity('bindDrag');
                });
              }
            }

        } // Detect keyboard 'ENTER' key on slides


        $(slide).keypress(function (event) {
          if (event.which == 13) {
            // Bring focus to media inside selected slide
            $(slide).find('model-viewer, .product-gallery__link, .plyr').focus(); // Run video autoplay logic if featured media is a video

            if (mediaType == 'video' || mediaType == 'external_video') {
              checkForVideos();
            } // Autoplay model if featured media is a model


            if (mediaType == 'model') {
              // If model container has class is-selected then play the model
              autoplayModel();
            }
          }
        });
      });
    });
    $productGallery.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: true,
      prevNextButtons: $productGallery.data('media-count') > 1 || $slides.length > 1 ? true : false,
      autoPlay: slideshowSpeed * 1000,
      fade: slideshowTransition === 'fade' ? true : false,
      watchCSS: this.template === 'image-scroll' ? true : false,
      arrowShape: arrowShape,
      cellAlign: 'left'
    });
    $productGallery.on('change.flickity', function () {
      $slides.each(function (index, slide) {
        //Determine media type of current slide
        var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');

        if ($(slide).hasClass('is-selected')) {
          //When active slide
          switch (mediaType) {
            case 'model':
              /* On slide change, if active slide contains 3d model
              * If on desktop, on hover, unbind flickity, after hover bind flickity
              * On model play event, unbind flickity to ensure model can be interacted with
              * On model pause event, bind flickity so that slide can be swiped
              * Pause all model slides when hidden
              */
              if (isScreenSizeLarge()) {
                // On mouseenter event, unbind flickity
                $(slide).on('mouseenter', function () {
                  $productGallery.flickity('unbindDrag');
                }); // On mouseleave event, bind flickity

                $(slide).on('mouseleave', function () {
                  $productGallery.flickity('bindDrag');
                });
              } // Listen for model pause/play events


              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function () {
                $productGallery.flickity('unbindDrag');
              });
              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', function () {
                $productGallery.flickity('bindDrag');
              });
              break;

            default:
              $productGallery.flickity('bindDrag');
          }
        } else {
          //When inactive slide
          switch (mediaType) {
            case 'external_video':
              //Youtube video pausing
              $.each(videoPlayers, function (index, player) {
                player.pause();
              });
              break;

            case 'video':
              //HTML5 video pausing
              $.each(videoPlayers, function (index, player) {
                player.pause();
              });
              break;

            case 'model':
              $.each(Shopify.theme.productMedia.models, function (index, model) {
                model.pause();
              });
          }
        }
      }); //Restore 3d model icons

      Shopify.theme.productMedia.showModelIcon($productGallery);
    }); // Checks for videos and plays them if they are the featured media
    // Autoplay logic only happens on desktop, autoplay set to off for mobile

    var $sliderArrows = $productGallery.find('.flickity-prev-next-button');

    if (($sliderArrows || $thumbnails) && isScreenSizeLarge()) {
      $sliderArrows.on('click', function () {
        $productGallery.on('settle.flickity', function (event, index) {
          // Find out media type of featured media slide
          var $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          var mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          var pId = $productGallery.data('product-id'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          if (mediaType == 'model') {
            // Sort models to get those in selected slide
            var sortedModels = [];
            $.each(Shopify.theme.productMedia.models, function (index, model) {
              if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
                sortedModels.push(model);
              }
            }); // If model container has class is-selected then play the model

            $.each(sortedModels, function (index, model) {
              var $slide = $(model.container).parents('.product-gallery__image');

              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          $productGallery.off('settle.flickity');
        });
        return false;
      });
      $thumbnails.on('click', function (event) {
        var index = $(event.currentTarget).index();
        $productGallery.flickity('select', index);
        $productGallery.on('settle.flickity', function (event, index) {
          // Find out media type of featured media slide
          var $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          var mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          var pId = $productGallery.data('product-id'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          if (mediaType == 'model') {
            // Sort models to get those in selected slide
            var sortedModels = [];
            $.each(Shopify.theme.productMedia.models, function (index, model) {
              if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
                sortedModels.push(model);
              }
            }); // If model container has class is-selected then play the model

            $.each(sortedModels, function (index, model) {
              var $slide = $(model.container).parents('.product-gallery__image');

              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          $productGallery.off('settle.flickity');
        });
        return false;
      });
      $thumbnails.keypress(function (event) {
        var index = $(event.currentTarget).index();

        if (event.which == 13) {
          $productGallery.flickity('select', index);
          var $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          var pId = $productGallery.data('product-id');
          $productGallery.on('settle.flickity', function (event, index) {
            $selectedSlide.find('model-viewer, .plyr, a').focus();
            $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
            $productGallery.off('settle.flickity');
          }); // Find out media type of featured media slide

          var mediaType = $selectedSlide.data('media-type') || $selected.find('[data-media-type]').data('media-type'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          if (mediaType == 'model') {
            // Sort models to get those in selected slide
            var sortedModels = [];
            $.each(Shopify.theme.productMedia.models, function (index, model) {
              if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
                sortedModels.push(model);
              }
            }); // If model container has class is-selected then play the model

            $.each(sortedModels, function (index, model) {
              var $slide = $(model.container).parents('.product-gallery__image');

              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          return false;
        }
      });
    }

    function checkForVideos() {
      $slides.each(function (index, slide) {
        // Variables
        var $slide = $(slide);
        var mediaType = $slide.data('media-type') || $slide.find('[data-media-type]').data('media-type');
        var videoID = $slide.find('video').data('plyr-video-id');
        var $iframeVideo = $slide.find('iframe');
        var iframeID = $iframeVideo.attr('id');

        if ($slide.hasClass('is-selected')) {
          if (mediaType == 'video') {
            videoID = $slide.find('video').data('plyr-video-id');

            if (videoID) {
              autoplayVideo(videoID, $slide);
            }
          } else if (mediaType == 'external_video' && iframeID) {
            autoplayYoutubeVideo(iframeID, $slide);
          }
        }
      });
    }

    function autoplayVideo(videoID, $slide) {
      // Compare id to player object and only play that video
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID) {
          player.play(); // On fullscreen toggle, focus back on the slide itself

          player.on('exitfullscreen', function () {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    function autoplayYoutubeVideo(iframeID, $slide) {
      // compare id to player object and only play that video
      $.each(videoPlayers, function (index, player) {
        if (player.playing) {
          player.pause();
        }

        if (player.media.id == iframeID) {
          player.play(); // On fullscreen toggle, focus back on the slide itself

          player.on('exitfullscreen', function () {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    setTimeout(function () {
      $productGallery.flickity('resize');
    }, 500);
    $(window).on('load', function () {
      $productGallery.flickity('resize');
    });

    if (thumbnailsEnabled == true && thumbnailsSliderEnabled == true && $slides.length > 1) {
      //If desktop determine which slider we build
      if (isScreenSizeLarge()) {
        if (thumbnailsPosition == 'right-thumbnails' || thumbnailsPosition == 'left-thumbnails') {
          $thumbnailProductGallery.addClass('vertical-slider-enabled');
          var navCellHeight = $thumbnails.height();
          var navHeight = $thumbnailProductGallery.height();
          $productGallery.on('select.flickity', function () {
            // set selected nav cell
            var flkty = $productGallery.data('flickity');

            if (flkty) {
              $thumbnailProductGallery.find('.is-nav-selected').removeClass('is-nav-selected');

              var _$selected = $thumbnails.eq(flkty.selectedIndex).addClass('is-nav-selected'); // scroll nav


              var scrollY = _$selected.position().top + $thumbnailProductGallery.scrollTop() - (navHeight + navCellHeight) / 2;
              $thumbnailProductGallery.animate({
                scrollTop: scrollY
              });
            }
          });
        } else {
          $thumbnailProductGallery.flickity({
            cellAlign: 'center',
            contain: true,
            groupCells: '80%',
            imagesLoaded: true,
            pageDots: true,
            prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
            asNavFor: this.template === 'image-scroll' && isScreenSizeLarge() ? '' : $productGallery[0],
            arrowShape: arrowShape
          }); // Ensures Flickity is not collapsed when loaded

          setTimeout(function () {
            $thumbnailProductGallery.flickity('resize');
          }, 500);
          $(window).on('load', function () {
            $thumbnailProductGallery.flickity('resize');
          });
        }
      } else {
        //Otherwise create standard thumbnail slider
        if($thumbnailProductGallery.hasClass('initialized')) {
          $thumbnailProductGallery.flickity('destroy');
        }
        $thumbnailProductGallery.flickity({
          cellAlign: 'center',
          contain: true,
          groupCells: '80%',
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
          asNavFor: this.template === 'image-scroll' && isScreenSizeLarge() ? '' : $productGallery[0],
          arrowShape: arrowShape
        });

        $thumbnailProductGallery.addClass('initialized')

        setTimeout(function () {
          $thumbnailProductGallery.flickity('resize');
        }, 500);
        $(window).on('load', function () {
          $thumbnailProductGallery.flickity('resize');
        });
      }
    }
  },
  enableProductSwatches: function enableProductSwatches() {
    $('body').on('change', '.swatch input[type="radio"]:not([name="sizing-options"])', function () {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      var parentForm = $(this).closest('.product_form form');

      $(`.swatch-element`).removeClass('swatch--active');
      $(`.swatch-element:has(label[for="${$(this).attr('id')}"])`).addClass('swatch--active');

      if (parentForm.siblings('.notify_form').length) {
        var notifyForm = parentForm.siblings('.notify_form');
      } else {
        var notifyForm = $('.js-notify-form');
      }

      var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
      var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
      var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

      if (option1 && option2 && option3) {
        var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
      } else if (option1 && option2) {
        var notifyMessage = option1 + ' / ' + option2;
      } else {
        var notifyMessage = option1;
      }

      notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage);
      $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    }); //Swatches linked with selected options

    if ($('.js-product_section').length) {
      var $productForms = $('.js-product_section').find('.product_form');
      $productForms.addClass('is-visible'); //Loop through each product and set the initial option value state

      $productForms.each(function () {
        var JSONData = $(this).data('product');
        var productID = $(this).data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).find('.swatch_options .swatch');

        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    } //Add click event when there is more than one product on the page (eg. Collection in Detail)


    if ($('.js-product_section').length > 1) {
      $('body').on('click', '.swatch-element', function () {
        var swatchValue = $(this).data('value').toString();
        $(this).siblings('input[value="' + swatchValue.replace(/\"/g, '\\"') + '"]').prop("checked", true).trigger("change");
        var JSONData = $(this).parents('.product_form').data('product');
        var productID = $(this).parents('.product_form').data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    }

    this.findSelectedVariantImage();
  },
  enableProductSwatchesAdvanced: function enableProductSwatchesAdvanced() { 
    var buttonState = false;
    $('.swatch .swatch-element').on('click', function(e){ 
      $(this).prev('input').trigger('change'); 
    });

    $('body').on('change', '.swatch :radio', function () {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      var parentForm = $(this).closest('.product_form form');
      var optionTitle = $(this).parent().parent().find('.variant_name');
      var optionAvailable = $(this).parent().parent().find('.swatch__title .variant_available');
      var infoAvailable = $(this).next('.swatch-element').find('.variant_available');

      if ( !buttonState ){
        buttonState = true;
        $('.button--add-to-cart').removeClass('init_disabled');
      }

      if (parentForm.siblings('.notify_form').length) {
        var notifyForm = parentForm.siblings('.notify_form');
      } else {
        var notifyForm = $('.js-notify-form');
      }

      var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
      var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
      var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

      if (option1 && option2 && option3) {
        var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
      } else if (option1 && option2) {
        var notifyMessage = option1 + ' / ' + option2;
      } else {
        var notifyMessage = option1;
      }

      optionTitle.html(optionValue);

      optionAvailable.html( infoAvailable.html() ).attr('data-stock', infoAvailable.attr('data-stock') );

      notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage);
      $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');

      return buttonState;
    }); //Swatches linked with selected options

    if ($('.js-product_section').length) {
      var $productForms = $('.js-product_section').find('.product_form');
      $productForms.addClass('is-visible'); //Loop through each product and set the initial option value state

      $productForms.each(function () {
        var JSONData = $(this).data('product');
        var productID = $(this).data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).find('.swatch_options .swatch');

        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    } //Add click event when there is more than one product on the page (eg. Collection in Detail)


    if ($('.js-product_section').length > 1) {
      $('body').on('click', '.swatch-element', function () {
        var swatchValue = $(this).data('value').toString();
        $(this).siblings('input[value="' + swatchValue.replace(/\"/g, '\\"') + '"]').prop("checked", true).trigger("change");
        var JSONData = $(this).parents('.product_form').data('product');
        var productID = $(this).parents('.product_form').data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    }

    this.findSelectedVariantImage();
  },
  findSelectedVariantImage: function findSelectedVariantImage() {
    $('[data-variant-selector]').on('selectedVariantChanged', function () {
      if ($(this).attr('disabled')) {
        return;
      } else {
        getIndex($(this), $(this).val());
      }
    });

    function getIndex($selector, variantID) {
      var $parentForm = $selector.parents('.product_form');
      var $option = $parentForm.find("select option[value=".concat(variantID, "]"));
      var imageID = $option.attr('data-image-id');

      if (!imageID) {
        // If there is no image, no scrolling occurs
        return false;
      }

      var index = $("[data-image-id=".concat(imageID, "]")).data('index');

      if (Shopify.theme.jsProduct.template === 'image-scroll') {
        Shopify.theme.jsProduct.scrollSelectedImage(index);
      }
    }
  },
  scrollSelectedImage: function scrollSelectedImage(variant) {
    var headerHeight = 0;
    var announceHeight = 0; // Get header height is sticky enabled

    if (Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
      headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
    } // Get announcement height is sticky enabled


    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
      announceHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    } // Add values


    //var totalHeight = headerHeight + announceHeight;
    //Shopify.theme.scrollToTop($("[data-index=\"".concat(variant, "\"]")), totalHeight);
  },
  relatedProducts: function relatedProducts() {
    $('.block__recommended-products .js-related-products-slider .products-slider').each(function (index, value) {
      var $relatedSlider = $(this);
      var slideData = {
        products_per_slide: $relatedSlider.data('products-per-slide'),
        products_available: $relatedSlider.data('products-available'),
        products_limit: $relatedSlider.data('products-limit'),
        initialIndex: 0,
        cellAlign: "left",
        wrapAround: true
      };

      var enable_buttons =  ($(window).width() > 768);

      if (slideData.products_available > slideData.products_per_slide && slideData.products_limit > slideData.products_per_slide) {
        slideData.wrapAround = true;
      } else {
        slideData.wrapAround = false;
      }

      if (slideData.products_available < slideData.products_per_slide || slideData.products_limit < slideData.products_per_slide) {

        $relatedSlider.addClass('container is-justify-center');
        $relatedSlider.find('.gallery-cell').addClass('column');
      } else {
        if (slideData.products_available > 4 && enable_buttons || slideData.products_available > 2 && !enable_buttons) {
          $relatedSlider.flickity({
            lazyLoad: 2,
            freeScroll: true,
            imagesLoaded: true,
            draggable: true,
            cellAlign: 'left',
            wrapAround: false,
            pageDots: false,
            contain: true,
            prevNextButtons: enable_buttons,
            initialIndex: slideData.initialIndex,
            arrowShape: arrowShape
          });
          setTimeout(function () {
            $relatedSlider.flickity('resize');
          }, 500);
          $(window).on('load', function () {
            $relatedSlider.flickity('resize');
          });
          theme.utils.fixFlikityPrevNextButton($relatedSlider, '[data-product-recommendations-container]');
        }
      }
    });
  },
  initStickyQuickBuy: function initStickyQuickBuy() {
    // desktop sticky init
    $('.product_sticky-quick-buy').sticky();

    // mobile sticky init
    $('.product_sticky-quick-buy-mobile').sticky({
      topSpacing:0,
      wrapperClassName: 'mobile_sticky-wrapper'
    });

    // add to cart
    $('.button--product_sticky-quick-buy').on('click', function(){
      if($(".variant_name")?.text()?.indexOf(' Size') > -1 ) {
        window.scrollTo(0, {})
        $('.product_form--dropdown-advanced .swatch__title').addClass('active').siblings('.swatch_options_wrap').slideDown();
        return
      }

      var $addToCartBtn = $(this);
      var reqData = $('.product_sticky-quick-buy .quick-buy__wrapper').serialize();
      //console.log(reqData);
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: reqData,
        beforeSend: function beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        },
        success: function success(product) {
          function addedToCart() {
            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }
  
            $el.addClass('show-mini-cart');
          }
          
          window.setTimeout(function () {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
          }, 1000);
          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();

          window.setTimeout(function () {
            Shopify.theme.jsAjaxCart.hideDrawer();
          }, 2000);
        }
      });
    }); 

    // change variants
    $('#quick-buy-variant-id').on('change', function(){
      var selectedId = $(this).val();
      var selectedVal = $(this).find('option[value=' + selectedId + ']').text();
      //console.log(selectedVal);
      $('.swatch-element[data-value='+ selectedVal +']').trigger('click');
      // var selectedId = $(this).val();
      // var product = $('.product_form_options').data("product");
      // var variants = product.variants;
      // for (let i = 0; i < variants.length; i++) {
      //   if (variants[i].id == selectedId) {
      //     console.log(product,variants[i].title);
      //   }
      // }
    });

    // mobile button add to cart
    $('#button--product_sticky-quick-buy-mobile').on('click', function(){
      if($(".container > .product-main .variant_name")?.text()?.indexOf('Size') > -1 ) {
        Shopify.theme.scrollToTop( $('.product__information_wrap') );
        $('.product_form--dropdown-advanced .swatch__title').addClass('active').siblings('.swatch_options_wrap').slideDown();
        return
      }
      var button = $('.product_form--dropdown-advanced .button--add-to-cart');
      if ( button.hasClass('init_disabled') || button.attr('disabled') == 'disabled' ) {
        Shopify.theme.scrollToTop( $('.product__information_wrap') );
        $('.swatch__title').addClass('error');
      } else {
        button.trigger('click');
      }
    });

  },
  initProductPairItWith: function initProductPairItWith() {
    // change price
    $('.product-pare-with_product_id').on('change', function(){
      var price = $(this).find('option:selected').attr('data-price');
      $(this).closest('.product-pare_item').find('.product_price').html(price);
    });

    // add to cart
    $('.product-pare-with_add_to_cart').on('click', function(){
      var $addToCartBtn = $(this);
      var form = $addToCartBtn.closest('form');
      var reqData = form.serialize();

      if ( $(form).find('.product-pare-with_product_id option:selected').val() == 'Choose your size' ) {
        alert('Please choose your size first');
      } else {
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: reqData,
          beforeSend: function beforeSend() {
            $addToCartBtn.attr('disabled', 'disabled');
          },
          success: function success(product) {
            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                Shopify.theme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }
    
              $el.addClass('show-mini-cart');
            }
            
            window.setTimeout(function () {
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
            }, 1000);
            Shopify.theme.jsAjaxCart.showDrawer();
            Shopify.theme.jsAjaxCart.updateView();
  
            window.setTimeout(function () {
              Shopify.theme.jsAjaxCart.hideDrawer();
            }, 2000);

            $addToCartBtn.removeAttr('disabled');
          }
        });
      }

    }); 
    
  },
  initProductAccordion: function initProductAccordion() {
    var $prodAccordionHeading = $('.product-accordion > dt > button');
    $prodAccordionHeading.on('click activate', function () {
      var title = $(this);
      var icons = $(this).find('.icon');
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $('.product-accordion > dd').not($(this).parent().next()).attr('aria-hidden', true).hide();
      $prodAccordionHeading.not($(this)).attr('aria-expanded', false);
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle(function () {
        if (icons.hasClass('icon--active')) {
          icons.toggleClass('icon--active');
        }
      });
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $prodAccordionHeading.on('keydown', function (event) {
      var keyCode = event.keyCode || e.which;

      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
    $('.product_description__accordion').on('click', function () {
      var $container = $(this).parent('.product_description__wrap');
      $container.toggleClass('active');
      if( $container.hasClass('active') ) {
        $container.find('.content').css("height","auto");
      } else {
        $container.find('.content').css("height","95px");
      }
    });
  },
  selectProductColor: function() {
    // this.$container.addClass('loading');
  },
  buildColourOptions: function() {
    var $container = this.$section.find('.js-product-colors-wrapper');
    var productGroupTag = $container.data('group');
    var that = this;

    if ( productGroupTag ){
      var apiUrl = window.theme.inventory_apps.app_token
      
      $.ajax({
        method: "POST",
        url: `https://${Shopify.shop}/api/2024-01/graphql.json`,
        contentType: "application/json",
        headers: {
          'X-Shopify-Storefront-Access-Token': `${apiUrl}`,
          'Content-Type': 'application/graphql'
        },
        data:             `
        query Swatches {
          collection(handle: "all") {
            handle
            products(first: 20, 
              filters: {
                productMetafield: {
                  namespace:"product",
                  key:"model_erp",
                  value:"${productGroupTag}"
              }
            }) {
              edges {
                node {
                  handle
                  title
                  onlineStoreUrl
                  availableForSale
                  featuredImage {
                    url
                  }
                  metafield: metafield(namespace: "product", key:"model_erp"){
                    value
                    description
                    type
                  }
                }
              }
            }
          }
        }
        `,
      }).then(function (data) {
        data = data.data.collection.products.edges.map(x => x.node);
        var colorItemsHtml = '';
        if(data.length > 1){
          for (let i = 0; i < data.length; i++) {
            var product = data[i];
            if (product.availableForSale) {
              if (  product.handle == that.handle) { //theme.current?.product?.handle == product.handle ||
                var specialСlass = 'current';
              } else {
                var specialСlass = '';
              }
              var colorName = product.title.split(' in ')[1];
              if (!colorName) {
                colorName = '';
              }

              //title="' + colorName + '"
              colorItemsHtml += '<a href="' + product.onlineStoreUrl + '" class="product-color-item-wrapper ' + specialСlass + '"><div class="product-color-item"><img src="' + product.featuredImage.url.replace('.jpg','_122x158.jpg').replace('.png','_122x158.png') + '" alt="' + product.title + '"></div></a>';
            }
          }
  
          $container.html(colorItemsHtml);
        }else {
          $container.hide();
        }

      });
    }
  },
  initInstoreAvailability: function() {
    var self = this;
    

    var selectors = {
      variantSelector: '[data-variant-selector] option:selected',
      quantitySelector: '.purchase-details .quantity-input',
      checkAvailability: '.button--check-availability',
      container: '#in-store-availability',
      variantIdSelector: 'input[name="variant_id"]'
    }

    var state = {
      loading: false,
      shown: false,
      stores: [],
      selectedStore: null,
      showChangeStore: false,
      noStock: false
    }

    this.$container = $(selectors.container)
    $(selectors.checkAvailability).on('click', fetchVariantAvailability);
    bindView();
    // document.querySelector(selectors.quantitySelector).addEventListener('input', resetState);

    $('[data-variant-selector]').on('selectedVariantChanged', resetState);
    $('.control').on('click', resetState); 
    $(selectors.quantitySelector).change(resetState)


    function resetState() {
      state.shown = false,
      state.selectedStore = null,
      state.showChangeStore = false,
      state.stores = [],
      state.noStock = false
    }

    function fetchVariantAvailability(event) {
      //var selectedVariant = $(selectors.variantSelector).attr('data-sku');
      var sku = $(selectors.variantSelector).attr('data-sku');
      if(!sku) {
        sku = $('p.sku').text().trim();
      }
      var selectedVariant = sku;
      var selectedQuantity = $(selectors.quantitySelector).val();
      var variant_id = $(selectors.variantIdSelector).val();
      var options = {
        "web_sku_ids": selectedVariant,
        "quantities": selectedQuantity
      }
      state.loading = true;
      const url = `${window.location.origin}/variants/${variant_id}/?section_id=pickup-availability`
      var apiUrl = window.theme.inventory_apps.app_token
      //console.log("apiUrl" , apiUrl)
      
      $.ajax({
          method: "POST",
          url: `https://${Shopify.shop}/api/2021-07/graphql.json`,
          contentType: "application/json",
          headers: {
            'X-Shopify-Storefront-Access-Token': `${apiUrl}`,
            'Content-Type': 'application/graphql'
          },
          data:             `{
            locations(first: 40) {
              edges {
                node {
                  id
                  name
                  address {
                    formatted
                  }
                }
              }
            }
          }`,
           success: function (data) {
            const ids = [];
            const storeDefaults = data.data.locations.edges.map((lo) => {
              const node = lo.node;
              const id = node.id.replace("gid://shopify/Location/",'');
              ids.push(id)
              return {
                  availability: false,
                  id: id,
                  location_name: node.name
                }
            })

            console.log(storeDefaults)

            $.ajax({
              method: "GET",
              url: url,
              headers: {
                'Content-Type': 'application/json'
              },
              success: function (data) {
                state.loading = false;
                state.shown = true;
                var htmlObject = document.createElement('div');
                htmlObject.innerHTML = data;
                var result = JSON.parse(htmlObject.querySelector("#shopify-section-pickup-availability").innerText.replaceAll('\n','').trim().replaceAll('',''));
                console.log(result)
                // if(excludeStores && excludeStores.length) {
                //   data.collection_options = data.collection_options.filter(store => !excludeStores.includes(store.location));
                // }
                state.stores = result.map(x => x.location);
                var idDiff = ids.filter(a => !state.stores.find(x => x.id == a));
                idDiff.forEach(x => {
                  state.stores.push(storeDefaults.find(st => st.id == x));
                })
                
                state.stores = state.stores.sort((a, b) => a.location_name.localeCompare(b.location_name))

                var selectedStore = result.find(store => store.available)?.location;
                if(!state.selectedStore) {
                  state.noStock = true
                }
                state.selectedStore  = selectedStore
                $('.in-store-availability__content').show();
              },
              error: function(error) {
                // displayError();
                state.loading = false;
              }
            });

           }
          })

      
    }

    function toggleChangeStore() {
      state.showChangeStore = !state.showChangeStore
    }

    function changeStore(event) {
      var id = $(event.target).attr('data-id');
      var selectedStore = state.stores.find(store => store.id == id);
      state.selectedStore = selectedStore;
    }

    function bindView() {
      tinybind.bind(self.$container, {
        data: state,
        methods: {
          changeStore: changeStore,
          toggleChangeStore: toggleChangeStore
        }
      });
    }

  },
  unload: function unload($section) {
    $('.selector-wrapper select', $section).unwrap();
    this.disableSlideshow($section);

    
    $('[data-variant-selector]').off();
    document.removeEventListener('lazybeforeunveil', Shopify.theme.jsProduct.enableZoom);
  }
};